import { useState } from "react";
import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";
import ArticleCard from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/base/SectionHeading";

const tabs = [{ slug: "all", name: "全部" }, ...categories.map((c) => ({ slug: c.slug, name: c.name }))];

export default function LatestArticles() {
  const [active, setActive] = useState("all");

  const list = articles
    .filter((a) => active === "all" || a.category === active)
    .sort((a, b) => (a.date < b.date ? 1 : -1));

  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-14">
        <SectionHeading
          eyebrow="内容更新"
          title="最新梳理与解读"
          desc="点击栏目切换，只看你关心的那一类信息。"
        />

        <div className="mb-8 flex flex-wrap gap-2">
          {tabs.map((t) => (
            <button
              key={t.slug}
              type="button"
              onClick={() => setActive(t.slug)}
              aria-pressed={active === t.slug}
              className={`cursor-pointer whitespace-nowrap rounded-full border px-4 py-1.5 text-sm transition-colors ${
                active === t.slug
                  ? "border-primary-500 bg-primary-500 text-background-50"
                  : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
              }`}
            >
              {t.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((a) => (
            <ArticleCard key={a.id} article={a} />
          ))}
        </div>

        {list.length === 0 && (
          <p className="rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-12 text-center text-sm text-foreground-500">
            该栏目暂无内容，可以先看看其他栏目。
          </p>
        )}

        <div className="mt-10 flex items-center justify-between gap-4 rounded-lg border border-background-200 bg-background-100 p-5">
          <p className="text-sm text-foreground-700">
            想按主题系统阅读？四个栏目都有独立列表与说明。
          </p>
          <Link
            to="/category/progress"
            className="hidden cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            从后续进展看起
          </Link>
        </div>
      </div>
    </section>
  );
}